import ProductEditForm from '../../components/retailer-products/ProductEditForm'
import BackButtonAndTitle from '../../components/retailer-shop/BackButtonAndTitle'

const RetailerEditProductPage = () => {
  return (
    <div className="main-container ">
      <BackButtonAndTitle title="Edit Product" />
      <ProductEditForm />
    </div>
  )
}

export default RetailerEditProductPage
